export const SeoText = ({ children }) => (
  <section className="px-6 py-16 section-alt">
    <div className="max-w-3xl mx-auto prose-content">
      {children}
    </div>
  </section>
);
